module.exports = __webpack_public_path__ + "static/media/mtn.ec802cda.jpg";